import React, { useCallback, useEffect, useState } from 'react';
import { Container, Stack, Paper, Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import Back from '../../../components/common/Back.component';
import Loading from '../../../components/common/Loading.component';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchAPI } from '../../../api/request';
import dayjs from 'dayjs';
import Alert from '../../../components/common/Alert.component';
import AddView from '../../../views/Add.view';
import technicalWork from '../../../module/technicalWork';
import technical from '../../../module/technical';
import { useLocation } from 'react-router-dom';

const TechnicalWorkAddPage = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const { jwt } = useSelector((state) => state.login);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const { loading: loadingGet, data } = useSelector(
    technical.edit.selector.data
  );

  const onError = useCallback(() => {
    setSuccess(false);
    setLoading(false);
    setError(true);
    // eslint-disable-next-line
  }, []);

  const onSuccess = useCallback(() => {
    setSuccess(true);
    setError(false);
    setLoading(false);
    // eslint-disable-next-line
  }, []);

  const onSubmit = useCallback(
    (values) => {
      const obj = {
        ...values,
        id_operation_list: id,
        time_in: values?.time_in
          ? dayjs(values?.time_in).format('HH:mm:ss')
          : null,
        time_out: values?.time_out
          ? dayjs(values?.time_out).format('HH:mm:ss')
          : null,
        id_yacht: data?.id_yacht?.id,
      };

      const formData = new FormData();

      if (obj?.na_tech_signature)
        formData.append(
          `files.na_tech_signature`,
          obj?.na_tech_signature,
          obj?.na_tech_signature?.name
        );
      if (obj?.yacht_crew_signature)
        formData.append(
          `files.yacht_crew_signature`,
          obj?.yacht_crew_signature,
          obj?.yacht_crew_signature?.name
        );
      formData.append('data', JSON.stringify(obj));

      setError(false);
      setSuccess(false);
      setLoading(true);
      fetchAPI(
        { path: '/technical-works', method: 'POST' },
        {},
        '',
        formData,
        jwt
      )
        .then((resp) => onSuccess(resp))
        .catch(onError);
    },
    [jwt, onError, onSuccess, id, data]
  );

  useEffect(() => {
    dispatch(
      technical.query.detail.action({
        settings: technical.query.detail.settings,
        token: jwt,
        params: { id },
        query: { populate: technical.query.detail.populate },
      })
    );

    return () => {
      dispatch(
        technical.query.detail.action({
          settings: null,
          token: null,
          params: null,
          query: null,
        })
      );
    };
  }, [id, dispatch, jwt]);

  useEffect(() => {
    if (state?.id !== id) {
      navigate('/404');
    }
  }, [state, navigate, id]);

  return (
    <Container disableGutters={true} maxWidth={false} sx={{ height: '100%' }}>
      <Stack
        spacing={2}
        sx={{ padding: 2 }}
        justifyContent='center'
        alignItems='center'
      >
        <Back />
        <Container>
          {(loading || loadingGet) && <Loading />}
          {success && <Alert severity='success'>{'Success: Add'}</Alert>}
          {error && <Alert severity='error'>{'An error has occurred'}</Alert>}

          <Paper variant='outlined'>
            <Box sx={{ padding: 2 }}>
              <AddView
                conf={technicalWork.create.conf}
                onAddSubmit={onSubmit}
                onAddError={onError}
                onAddSuccess={onSuccess}
                disabled={loading || success}
              />
            </Box>
          </Paper>
        </Container>
      </Stack>
    </Container>
  );
};

export default TechnicalWorkAddPage;
